<!-- 网站服务条款及用户协议 -->
<template>
  <div class="protocol">
    <p class="title">网站服务条款及用户协议</p>
    <p>当您在本站进行下载时，表示您已经同意遵守本规章。</p>
    <p>欢迎您加入本站点参加交流和讨论，为维护网上公共秩序和社会稳定，请您自觉遵守以下条款：</p>
    <p>一、不得利用本站危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得利用本站制作、复制和传播下列信息：</p>
    <p>(一)煽动抗拒、破坏宪法和法律、行政法规实施的;</p>
    <p>(二)煽动颠覆国家政权，推翻社会主义制度的;</p>
    <p>(三)煽动分裂国家、破坏国家统一的;</p>
    <p>(四)煽动民族仇恨、民族歧视，破坏民族团结的;</p>
    <p>(五)捏造或者歪曲事实，散布谣言，扰乱社会秩序的;</p>
    <p>(六)宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的;</p>
    <p>(七)公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的;</p>
    <p>(八)损害国家机关信誉的;</p>
    <p>(九)其他违反宪法和法律行政法规的;</p>
    <p>(十)进行商业广告行为的。</p>
    <p>二、互相尊重，对自己的言论和行为负责。</p>
    <p>三、禁止在申请用户时使用相关本站的词汇，或是带有侮辱、毁谤、造谣类的或是有其含义的各种语言进行注册用户，否则我们会将其删除。</p>
    <p>四、禁止以任何方式对本站进行各种破坏行为。</p>
    <p>五、如果您有违反国家相关法律法规的行为，本站概不负责，您的登录论坛信息均被记录无疑，必要时，我们会向相关的国家管理部门提供此类信息。</p>
    <p>六、用户上传资源作为网上学习交流使用，视为资源版权归原创作者和网站共同所有，如用户上传非原创资源，应自行解决相关版权问题，否则，由此引起版权纠纷与本网站无关，网站不负任何法律责任。</p>
    <p>七、网站所有游戏包均由游戏发行商提供，由此引起的版权纠纷与本网站无关。</p>
    <p>八、凡以任何方式访问本论坛或直接、间接使用网站信息者，视为自愿接受网站免责声明的约束。</p>
    <p>九、用户注册后如果长期不使用，网站权收回帐号，以免造成资源浪费，由此带来的包括并不限于用户资料、邮件和游戏虚拟道具丢失等损失由用户自行承担。</p>
    <p>十、本免责条款以及其修改权、更新权及最终解释权均属网站所有。</p>
    <p>本应用需18周岁以上才可进行下载。如不满18周岁，需在监护人的监护下才可下载!</p>
    <p>为保护未成年人身心健康，未满18岁的用户将受到防沉迷系统的约束。</p>
  </div>
</template>

<script>
export default {
  name: "Protocol",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "protocol");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.protocol {
  width: 1000px;
  margin: 60px auto;
}

.title {
  font-size: 20px;
  color: #e1556d;
  text-align: center;
  margin-bottom: 40px;
}

p {
  text-indent: 2em;
  font-size: 18px;
  color: #303032;
  line-height: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Protocol.vue